import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { i as inheritAriaAttributes } from './p-198613ef.js';
import { c as classNames } from './p-df8c8ec2.js';

const biBadgeCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}:host{position:relative;display:inline-block;height:fit-content}span{position:absolute;background-color:#9f1613;border:1px solid #9f1613;border-radius:50%;width:14px;height:14px;display:flex;justify-content:center;align-items:center;text-align:center;z-index:2}span p{color:white;font-family:\"museo-sans\", arial, sans-serif, sans-serif;font-size:0.625rem;font-weight:500;line-height:1.5;z-index:2}.goldAccent{background-color:#ffde8c;border:#ffde8c}.goldAccent p{color:black}.large{width:18px;height:18px}.large p{font-size:0.75rem;line-height:1.5}.small{width:12px;height:12px}.small p{font-size:0.5625rem;line-height:1.5}.top-left{top:0;left:0}.top-right{top:0;right:0}.bottom-left{bottom:0;left:0}.bottom-right{bottom:0;right:0}";
const BiBadgeStyle0 = biBadgeCss;

const BiBadge$1 = /*@__PURE__*/ proxyCustomElement(class BiBadge extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        /**
         * The color of the badge.
         */
        this.color = 'redAccent';
        /**
         * The size of the badge.
         */
        this.size = 'medium';
        /**
         * The position of the badge.
         * Can be 'top-left', 'top-right', 'bottom-left', or 'bottom-right'.
         */
        this.position = 'top-right';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
    }
    render() {
        return (h(Host, { key: '4b0f03d6dd14c87941f10a20585d5f129332bb5b' }, h("slot", { key: 'd7eaf01a1435959a60cc95bc7afe4cd063dd0ccb' }), h("span", { key: 'b7acfe98836aa62f3011082d8f9f96544fd4f13a', class: classNames(this.size, this.color, this.position) }, h("p", { key: '1616363243514f5599b24226e36b7a4f5f173a9d', ...(this.inheritedAttributes['aria-label'] ? { role: 'status' } : {}), ...this.inheritedAttributes }, this.count))));
    }
    get el() { return this; }
    static get style() { return BiBadgeStyle0; }
}, [1, "bi-badge", {
        "count": [2],
        "color": [1],
        "size": [1],
        "position": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-badge"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-badge":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiBadge$1);
            }
            break;
    } });
}

const BiBadge = BiBadge$1;
const defineCustomElement = defineCustomElement$1;

export { BiBadge, defineCustomElement };
